import React from "react";
import { Siren, Info } from "lucide-react";
import { EMERGENCY_LINE, FOOTER_NOTICE } from "@/lib/academy";

export function ProgressRing({ pct = 0, size = 120, stroke = 10, label }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="academy-progress-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#27272a" strokeWidth={stroke} fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke="url(#ra-g)" strokeWidth={stroke} fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c - (c * Math.min(pct, 100)) / 100} style={{ transition: "stroke-dashoffset .8s ease" }} />
        <defs><linearGradient id="ra-g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#3b82f6" /><stop offset="1" stopColor="#FFCC00" /></linearGradient></defs>
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <div>
          <div className="text-2xl font-bold text-zinc-50">{pct}%</div>
          {label && <div className="text-[11px] uppercase tracking-wider text-zinc-500">{label}</div>}
        </div>
      </div>
    </div>
  );
}

export function EmergencyNotice() {
  return (
    <div className="flex items-center gap-2.5 rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-2.5 text-[13px] font-semibold text-red-200" data-testid="academy-emergency-notice">
      <Siren size={16} className="shrink-0 text-red-400" /> {EMERGENCY_LINE}
    </div>
  );
}

export function LessonFooter() {
  return (
    <div className="mt-8 flex gap-2.5 border-t border-zinc-800 pt-4 text-[12px] leading-relaxed text-zinc-500" data-testid="academy-lesson-footer">
      <Info size={14} className="mt-0.5 shrink-0" /> {FOOTER_NOTICE}
    </div>
  );
}

export function Stat({ icon: Icon, label, value, testid }) {
  return (
    <div className="rounded-xl border border-zinc-800/70 bg-[#111113] p-4" data-testid={testid}>
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-zinc-500"><Icon size={13} /> {label}</div>
      <div className="mt-2 text-xl font-bold text-zinc-50">{value}</div>
    </div>
  );
}
